import React from "react"
import { theme } from "antd"
import Tippy from "@tippyjs/react"
import classNames from "classnames"

import { WithCopy } from "@src/shared/componemts/WithCopy"
import { cutEnd, paddingLimit } from "@src/shared/strings"
import css from "./index.module.css"

type Props = {
  className?: string
  cut?: boolean
  id: string
  onClick?: () => void
  p?: number
}
export const IdItem = ({
  className,
  cut = false,
  id,
  onClick,
  p = 5,
}: Props) => {
  const { token } = theme.useToken()
  const transformText = (id: string) => {
    if (cut) {
      return cutEnd(id, p)
    }

    return paddingLimit(id, 0, p)
  }

  return (
    <div
      className={classNames([css.container, className])}
      style={{ color: token.colorPrimary }}
    >
      <WithCopy
        buttonClassName={css.button}
        buttonWrapperClassName={css.buttonCell}
        content={id}
        style={{ width: "100%" }}
        view={
          <Tippy className={css.tooltip} content={id} placement="top-start">
            <span
              className={css.id}
              onClick={onClick}
              style={onClick ? { cursor: "pointer" } : {}}
            >
              {p === id.length ? id : transformText(id)}
            </span>
          </Tippy>
        }
      />
    </div>
  )
}
